module.exports = __webpack_public_path__ + "static/media/LeBros.72c53d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/TestimonialsCarousel/assets/partner/LeBros.png
// module id = 1105
// module chunks = 0